import '../css/MiniPagination.less';

import classNames from 'classnames';
import React from 'react';
import makeComp from '../util/profiler';

interface MiniPaginationProps {
  pageCount: number;
  currentPage: number;
}

const MiniPagination: React.FC<MiniPaginationProps> = makeComp(
  props => {
    return (
      <div className="mini-pagination">
        {[...Array(props.pageCount)].map((_, i) => (
          <div
            key={i}
            className={classNames('dot', {active: i === props.currentPage})}
          />
        ))}
      </div>
    );
  },
  {id: 'MiniPagination'}
);

export default MiniPagination;
